/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab.ts";

function getGetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabUrl(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/financial-tab` as const,
  };
  return res;
}

/**
 * @description Retorna informações de pagamento, forma de pagamento, plano, parcelas, descontos e taxas da matrícula, para exibição na aba Financeiro do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna dados financeiros de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/financial-tab}
 */
export async function getApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTabUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
